<!--
 * @Description: 深度取证
 * @Date: 2019-12-26 10:47:05
 * @LastEditTime: 2021-06-22 13:50:37
 -->

<template>
  <div id="deepForensicCreate">
    <div class="content-wrap">
      <LoadImg v-if="!loaded && item.sourceImagePath && (checkFileType(item.fileOrioriginalName) == 'img')" v-model="loaded" :src="item.sourceImagePath" />
      <!--/图片加载占位符-->
      <div v-if="checkFileType(item.fileOrioriginalName) == 'pdf'" class="file-placeholder">
        <img src="../../assets/imgs/file.png" alt="">
      </div>
      <!--/PDF文件占位符-->
      <div v-if="checkFileType(item.fileOrioriginalName) == 'video'" class="file-placeholder">
        <img src="../../assets/imgs/u994.svg" alt="">
      </div>
      <!--/视频文件占位符-->
      <img v-if="loaded && (checkFileType(item.fileOrioriginalName) == 'img')" class="img" :src="item.sourceImagePath">
      <el-form ref="createForm" class="form-wrap" :model="createForm" label-position="right" label-width="106px" size="small">
        <el-row>
          <el-col :span="8">
            <el-form-item label="上传时间：" prop="createTime">
              <span>{{ createForm.createTime }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="取证用户：" prop="username">
              <span>{{ createForm.username }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="备注："
              prop="remark"
              :rules="[{ max: 200, message: '备注最大长度为200', trigger: 'blur' }]"
            >
              <el-input v-model="createForm.remark" class="textarea" type="textarea" placeholder="请输入委托背景及期望目标" />
            </el-form-item>
          </el-col>
          <el-col :span="24" class="foot-btns-wrap">
            <el-button @click="backTo">
              取消
            </el-button>
            <el-button type="primary" :loading="submitLoading" @click="handleSubmit">
              提交
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { LoadImg } from '@/components'
import { checkFileType } from '../selfForensic/Config';

export default {
  components: { LoadImg },
  data() {
    return {
      createForm: {
        id: '',
        createTime: '',
        username: '',
        // monitorEquipmentType: '',
        // photographEquipmentType: '',
        // estimateScreenTime: '',
        // minEstimateScreenTime: '',
        // maxEstimateScreenTime: '',
        // imageReceiveType: 3,
        remark: ''
      },
      loaded: false,
      checkFileType,
      imageTypeOptions: [
        {
          value: 1,
          label: '虚拟打印的电子图'
        },
        {
          value: 2,
          label: '打印扫描图'
        },
        {
          value: 3,
          label: '手机或屏幕截屏图'
        },
        {
          value: 4,
          label: '纸张拍照图'
        },
        {
          value: 5,
          label: '屏幕拍照图'
        }
      ],
      item: ''
    };
  },
  computed: {
    ...mapState({
      itemPromise: state => state.forensic.item,
      submitLoading: state => state.deepForensic.submitLoading,
      productName: state => state.product.item.productName
    })
  },
  watch: {},
  mounted() {
    this.itemPromise().then((data) => {
      this.item = data
      this.createForm.createTime = data.createTime
      this.createForm.username = data.username
      this.createForm.id = data.id
    })
  },
  methods: {
    ...mapActions({
      checkNumber: 'deepForensic/checkNumber',
      create: 'deepForensic/create'
      // createPrint: 'deepForensic/createPrint'
    }),
    // 提交深度取证
    handleSubmit() {
      this.$refs.createForm.validate((valid) => {
        if (valid) {
          this.checkNumber({ userId: this.item.userId }).then(res => {
            const { id, remark } = this.createForm
            // this.createPrint({ fId: id, remark, imageReceiveType }).then(res => {
            //   this.handleSuccess()
            // })
            this.create({ id, remark }).then(res => {
              this.handleSuccess()
            })
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 提交成功
    handleSuccess() {
      this.$message({
        type: 'success',
        message: '提交成功',
        center: true
      })
      this.linkTo('/deepForensic/list')
    }
  }
};
</script>
 <style lang="scss">
#deepForensicCreate {
  padding: 15px 0 50px 0;
  .content-wrap {
    width: 1000px;
    margin: 0 auto;
    .file-placeholder {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 60px 0;
    }
    .img {
      width: 100%;
      min-height: 400px;
    }
    .form-wrap {
      margin-top: 20px;
      .foot-btns-wrap {
        text-align: center;
        margin-top: 20px;
        .el-button {
           width: 88px;
          height: 40px;
          padding: 0;
        }
      }
      .el-input--small {
        input {
          height: 34px;
          line-height: 34px;
        }
      }
      .el-date-editor {
        width: 100%;
        height: 34px;
      }
      .el-select {
        width: 100%;
        .el-select__caret {
          line-height: 34px
        }
      }
      .textarea {
        .el-textarea__inner {
          height: 120px;
        }
      }
      .uploadData {
        width: 600px;
        height: 50px;
        margin: auto;
        .el-col {
          width: 300px;
        }
      }
    }
  }
}
</style>
